<template>
<div>
  <b-card
    v-if="data"
    class="earnings-card"
  >
    <b-row>
      <b-col cols="6">
        <b-card-title class="mb-1">

           <feather-icon
            icon="BriefcaseIcon"
            size="33"
            :class="'text-primary'"
          />
        {{$t('Contrcats Informations')}}
        </b-card-title>



       <div class="font-small-2">
         <feather-icon
            icon="CircleIcon"
            size="16"
            :class="'text-primary'"
          />
          {{$t('Counts  of contrcats')}} :  {{data.Contracts.count}}
        </div>

         <div class="font-small-2">
           <feather-icon
            icon="CalendarIcon"
            size="16"
            :class="'text-primary'"
          />
          {{$t('last Dashbord update')}} :  {{data.DateTime}}
        </div>


        
        <!-- <b-card-text class="text-muted font-small-2">
          <span class="font-weight-bolder">68.2%</span><span> more earnings than last month.</span>
        </b-card-text> -->
      </b-col>
      <b-col cols="6" class="pull-right">


         <b-media no-body>
          
              <b-media-aside class="mr-0">
               <b-link @click="showList(data.Contracts.list)">
                  <b-avatar size="48" variant="light-primary">
                    <feather-icon size="24" icon="ListIcon" />
                  </b-avatar>
               </b-link>
              </b-media-aside>

              <b-media-body class="my-auto">
                <h5 class="font-weight-bolder mt-1 ">
                   <b-link @click="showList(data.Contracts.list)"> {{$t('Show list of contrcats')}}</b-link>
                 
                </h5>
                <b-card-text class="font-small-3 mt-2  ">

                  
                </b-card-text>
                
              </b-media-body>
             
            </b-media>
        

      </b-col>
    </b-row>
  </b-card>
 <div>
      <b-modal v-model="show" title="title" title-tag="div">
        <table-widget :items="modalData" :fields="fields" title="title" />
        <b-container fluid>

   <br/>
        </b-container>
         <!-- <b-row>

          <b-col xl="6">
        <b-button v-if="title!='Contrcats'" @click="exportData(title,'pdf',modalData)" type="button" variant="primary" class="mr-1 ">
          {{ $t('Export PDF') }}
        </b-button>
          </b-col>
          <b-col xl="6">
       <b-button v-if="title!='Contrcats'"  @click="exportData(title,'xlsx',modalData)" type="button" variant="primary" class="mr-1 pull-left">
          {{ $t('Export Excel') }}
        </b-button>
        </b-col>
</b-row> -->
      </b-modal>
    </div>
  </div>
</template>

<script>

import {
  BCard, BRow, BCol, BCardTitle, BCardText,BProgress, BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,BTable, BPagination,BFormSelect,BButton
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import store from '@/store'
import { codeKitchenSink } from './code'
import { ref ,computed} from '@vue/composition-api'
import TableWidget from './modals/TableWidget.vue';
import { F } from 'caniuse-lite/data/agents';
import axios from '@/libs/axios'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BProgress,
    BCardTitle,
    BCardText,
    VueApexCharts,
     BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,BTable, BPagination,BFormSelect,BButton,TableWidget
  },
  props:{
   
    data: {
      type: Object,
      default: () => {},
    },
     chartsData:{
      type: Array,
      default:()=>{}

    }
  },
  computed:{


  },
setup(props){

   

const show=ref(false);

const modalData=ref([]);
const fields=ref([])
const title=ref("")
const dashDate=ref("");

const showList=(data)=>{
 // console.log('ddddddddddddddddd',data)
   show.value=true;
   modalData.value=data;
   fields.value=[{key:'id','label':'id'},{key: 'name', label: 'name'},{ key: 'group', label: 'group', sortable: true },]
   title.value="wwwwww";
  
   
  
}

 const exportData =(listType,exportType,data)=>{


const dateTime =store.state.DashBoardStore.dashData.General.DateTime;


const postedData={
  "exportType":exportType,
  "listType":listType,
  "dateTime":dateTime,
  "data":data

}


return new Promise((resolve, reject) => {
      axios.post(`dashboard/exportDevices/`, postedData,{
          responseType: 'blob'
      })
        .then(response => {
      const type = response.headers['content-type']
      const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })      
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'file'+dateTime+'.'+exportType
      link.click()
        })
        .catch(reason => reject(reason.response))
    })



    }
return {
  showList,
  show,
  modalData,
  fields,
  title,
   dashDate,

  exportData,
}

  }
}
</script>
